import type { Timing } from "./timing";
import type { Side } from "./operation";

/**
 * BattleEvent 的数据结构或可选取值约定。
 */
export interface BattleEvent {
    /**
     * timing，保存当前实例的timing状态。
     */
    timing: Timing;
    /**
     * side，保存当前实例的side状态。
     */
    side?: Side;
    /**
     * effect，保存当前实例的effect状态。
     */
    effect?: string;
    /**
     * succeeded，保存当前实例的succeeded状态。
     */
    succeeded?: boolean;
    /**
     * petId，保存当前实例的petId状态。
     */
    petId?: number;
    /**
     * eventPetId，保存当前实例的eventPetId状态。
     */
    eventPetId?: number;
    /**
     * source，保存当前实例的source状态。
     */
    source?: string;
}

/** 每次技能释放的新上下文；不把结算控制标志写入展示面板。 */
export class ActionContext {
    /**
     * sealed，保存当前实例的sealed状态。
     */
    sealed = false;
    /**
     * attackImmune，保存当前实例的attackImmune状态。
     */
    attackImmune = false;
    /**
     * ignoreAttackImmunity，保存当前实例的ignoreAttackImmunity状态。
     */
    ignoreAttackImmunity = false;
    /**
     * hitEffectsInvalid，保存当前实例的hitEffectsInvalid状态。
     */
    hitEffectsInvalid = false;
    /**
     * evasionRates，保存当前实例的evasionRates状态。
     */
    evasionRates: number[] = [];
    /**
     * instakill，保存当前实例的instakill状态。
     */
    instakill = false;
}

/**
 * MissReason 的数据结构或可选取值约定。
 */
export type MissReason = "sealed" | "accuracy" | "evasion" | "attackImmune";
/**
 * missLabels，供本模块相关规则使用。
 */
export const missLabels: Record<MissReason, string> = {
    sealed: "技能被封印",
    accuracy: "命中率判定失败",
    evasion: "技能被闪避",
    attackImmune: "师盔阻止攻击",
};

/**
 * UseSkillResult 的数据结构或可选取值约定。
 */
export interface UseSkillResult {
    /**
     * used，保存当前实例的used状态。
     */
    used: boolean;
    /**
     * blockReason，保存当前实例的blockReason状态。
     */
    blockReason?: string;
    /**
     * hit，保存当前实例的hit状态。
     */
    hit?: boolean;
    /**
     * missReason，保存当前实例的missReason状态。
     */
    missReason?: MissReason;
    /**
     * hitEffectsApplied，保存当前实例的hitEffectsApplied状态。
     */
    hitEffectsApplied?: boolean;
    /**
     * damage，保存当前实例的damage状态。
     */
    damage?: number;
    /**
     * criticalHit，保存当前实例的criticalHit状态。
     */
    criticalHit?: boolean;
}
